<script setup>
import { ref } from 'vue';
import RichText from '@/components/pages/RichText.vue';
import FordButton from '@/components/FordButton.vue';
import VideoModal from '@/components/modal/VideoModal.vue';
import MoreInfoModal from '@/components/modal/MoreInfoModal.vue';
import GenericEvent from '@/components/events/GenericEvent.vue';
import InfoItem from '@/components/events/InfoItem.vue';
import DisclosurePopover from '@/components/DisclosurePopover.vue';

defineProps({
  event: Object,
  solutions: Array,
});

const showVideoModal = ref(false);

const toggleVideoModal = () => { showVideoModal.value = !showVideoModal.value; };

const showMoreInfoModal = ref(false);
const toggleMoreInfoModal = () => { showMoreInfoModal.value = !showMoreInfoModal.value; };

</script>
<template>
  <video-modal v-if="showVideoModal"
    :title="event?.name"
    :src="event?.videoId"
    @close="toggleVideoModal" />
  <more-info-modal v-if="showMoreInfoModal"
    :id="event?.id"
    :showQuestion="event?.showQuestionFieldOnRegistration"
    :solutions="solutions"
    @close="toggleMoreInfoModal" />
  <generic-event :event="event">
    <template v-slot:hero-button>
      <ford-button v-if="event?.videoId"
        invert
        @method="toggleVideoModal"
        ariaLabel="Play Video Now">Play Now</ford-button>
    </template>
    <template v-slot:info-area-details>
      <div
        class="
          grid
          grid-cols-1
          tablet:grid-cols-3
          tablet:gap-[2rem] desktop:gap-[8rem]
        ">
        <dl class="mb-[1.8rem]">
          <info-item label="Duration" :value="event?.duration" class="capitalize mb-[2rem]"/>
          <info-item v-if="event?.location" label="Location" :value="event?.location" />
        </dl>
        <div class="tablet:row-start-1 tablet:col-span-2">
          <rich-text :content="event?.descriptionDetail" class="mb-8" />
          <div v-if="event.disclosureEvent" class="mb-8">
            <disclosure-popover>
              {{ event.disclosureEvent }}
            </disclosure-popover>
          </div>
          <ford-button v-if="event?.showGetMoreInformationButton"
            @method="toggleMoreInfoModal"
            class="mb-[2rem]"
            transparent
            ariaLabel="Get more information about the event">
            Get More Information</ford-button>
        </div>
      </div>
    </template>
  </generic-event>
</template>
